import React, { useContext, useEffect } from 'react'
import { Button, Form, InputGroup, Modal } from 'react-bootstrap'
import { FaTimes } from "react-icons/fa"
import { VideoPopupContext } from "../../App"
import { useForm } from "react-hook-form";
import { SPECIAL_CHARACTER_ARRAY, VALIDATIONS, VALIDATIONS_TEXT } from '../../constants/app-constants';
import { success, error } from "../../constants/msg";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Assets from '../../constants/images';
import Player from '../home/Player';

const VideoPopup = ({data}) => {
    const [handleVideoPopup, setHandleVideoPopup] = useContext(VideoPopupContext);

    return (
        <div>
            <ToastContainer />
            <Modal
                className='player-modal'
                show={handleVideoPopup}
                onHide={()=>setHandleVideoPopup(false)}
                size="md"
                centered
                aria-labelledby="contained-modal-title-vcenter"
            >
                <Modal.Body>
                    <div className="header">
                        <div onClick={() => setHandleVideoPopup(false)} className="fa-times"><FaTimes /></div>
                    </div>

                    <div className='p-1 bg-white br-20'>
                        <Player data={data} isAudioPlayer={false} show1="d-none" show2="d-block" paddingY="py-4" />
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default VideoPopup